import { supabaseKey } from "../constant/SupabaseKey";
function returnValidFileNameSupabase(fileName: string){
    // Xóa bỏ các dấu cách và thay thế bằng gạch dưới hoặc gạch ngang
    return `${supabaseKey.REACT_APP_SUPABASE_URL}/storage/v1/object/public/${fileName}`;
};
export default returnValidFileNameSupabase;